var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8789 5.85156L18.3984 6.37109C19 6.97266 19 7.92969 18.3984 8.53125L17.5781 9.35156L14.8984 6.67188L15.7188 5.85156C16.3203 5.25 17.2773 5.25 17.8789 5.85156ZM9.70312 11.8672L14.2695 7.30078L16.9492 9.98047L12.3828 14.5469C12.2188 14.7109 12 14.8477 11.7812 14.9297L9.34766 15.7227C9.12891 15.8047 8.85547 15.75 8.69141 15.5586C8.5 15.3945 8.44531 15.1211 8.52734 14.9023L9.32031 12.4688C9.40234 12.25 9.53906 12.0312 9.70312 11.8672ZM7.625 7H10.25C10.7148 7 11.125 7.41016 11.125 7.875C11.125 8.36719 10.7148 8.75 10.25 8.75H7.625C7.13281 8.75 6.75 9.16016 6.75 9.625V16.625C6.75 17.1172 7.13281 17.5 7.625 17.5H14.625C15.0898 17.5 15.5 17.1172 15.5 16.625V14C15.5 13.5352 15.8828 13.125 16.375 13.125C16.8398 13.125 17.25 13.5352 17.25 14V16.625C17.25 18.0742 16.0742 19.25 14.625 19.25H7.625C6.17578 19.25 5 18.0742 5 16.625V9.625C5 8.17578 6.17578 7 7.625 7Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.1ab7a4fd5bf4132d9bf7bc5518303c70.svg";
export { ForwardRef as ReactComponent };